import { AppConfigStructure } from './config';

const localConfig: AppConfigStructure = {
  name: 'local',

  intercom: {
    isOn: false,
  },

  sentry: {
    isOn: false,
    DSN: 'https://0cd6aef08375436998965905c89961c9@sentry.io/1280773',
  },

  fullStory: {
    isOn: false,
  },

  isStaffModeAllowed: true,

  eventTracker: {
    isOn: false,
  },

  splitFeatureFlagSystem: {
    isOn: true,
    key: '723rg4o5ndu20a0dcq0jh37r5bnks2lr1ahb',
  },

  //identityEndpointSlug: 'identity.gloat-dev',

  features: {
    isNewSearch: true,
  },
};

export default localConfig;
